/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  InteractSubTypes,
  InteractSubLevel,
  SubPeriodTypes,
  XmlaSubscriptionTypeEx,
  XmlaSubscriptionLevelEx,
} from "../../../api/models";

export interface EditXmlaSubscriptionPricesDialogData {
  dialogTitle: string;
  xmlaSubscriptionTypes: XmlaSubscriptionTypeEx[];
  xmlaSubscriptionLevels: XmlaSubscriptionLevelEx[];
  subPeriodTypes: SubPeriodTypes[];
  isNew: boolean;
  subscriptionTypeId: number;
  subscriptionLevelId: number;
  periodTypeId: number;
  price: number;
}

@Component({
  selector: "edit-xmla-subscription-price-dialog",
  styleUrls: ["edit-xmla-subscription-price-dialog.component.css"],
  templateUrl: "./edit-xmla-subscription-price-dialog.component.html",
})
export class EditXmlaSubscriptionPricesDialogComponent {
  public Result: DialogResult;
  public filteredSubLevels: XmlaSubscriptionLevelEx[] = [];

  constructor(
    public dialogRef: MatDialogRef<EditXmlaSubscriptionPricesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditXmlaSubscriptionPricesDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  selectedSubTypeChanged() {
    this.filteredSubLevels = [];
    for (var i = 0; i < this.data.xmlaSubscriptionLevels.length; i++) {
      if (
        this.data.xmlaSubscriptionLevels[i].xmlaSubscriptionTypeId ==
        this.data.subscriptionTypeId
      ) {
        this.filteredSubLevels.push(this.data.xmlaSubscriptionLevels[i]);
      }
    }
  }
}

/* Calling Methods */
/*
  callEditSubPrices(params: EditSubPricesDialogData) {
    var dialogRef = this.dialog.open(EditSubPricesDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
